import Logo from "./Logo";
import { scrollToId } from "@/lib/scroll";

const cols = [
  {
    title: "Product",
    links: [
      { label: "How It Works", href: "#how" },
      { label: "Capabilities", href: "#features" },
      { label: "The Problem", href: "#problem" },
      { label: "Pricing", href: "#pricing" },
      { label: "FAQ", href: "#faq" },
      { label: "vs Answering Services", href: "/compare" },
      { label: "Resources", href: "/resources" },
      { label: "Automatic Demo", href: "/demo" },
      { label: "Customer Login", href: "/portal" },
    ],
  },
  {
    title: "Industries",
    links: [
      { label: "HVAC Contractors", href: "/" },
      { label: "Plumbers", href: "/plumbers" },
      { label: "Electricians", href: "/electricians" },
      { label: "Roofers", href: "/roofers" },
      { label: "General Contractors", href: "/contractors" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/[0.08] bg-[#0B0D10]">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8">
        <div className="flex flex-col justify-between gap-12 lg:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <Logo size={34} />
              <span className="font-display text-lg font-bold tracking-tight text-slate-50">
                Backfill
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              The revenue recovery engine for HVAC contractors. Missed calls
              in, booked jobs out — without hiring another dispatcher.
            </p>
            <div
              data-testid="system-status-badge"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-emerald-400/25 bg-emerald-400/[0.07] px-3.5 py-1.5"
            >
              <span className="relative flex h-2 w-2">
                <span className="ping-slow absolute inline-flex h-full w-full rounded-full bg-emerald-400" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              <span className="font-mono text-[11px] uppercase tracking-wider text-emerald-400">
                All systems operational
              </span>
            </div>
          </div>

          <div className="flex gap-16 sm:gap-24">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
                  {c.title}
                </p>
                <ul className="mt-4 space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        onClick={(e) => {
                          if (l.href.startsWith("/")) return;
                          e.preventDefault();
                          scrollToId(l.href);
                        }}
                        className="text-sm text-slate-400 transition-colors duration-200 hover:text-[#F25F22]"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 sm:flex-row">
          <p className="text-xs text-slate-500">
            © 2026 Backfill Systems, Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-slate-500">
            <a href="#top" data-testid="footer-privacy" onClick={(e) => e.preventDefault()} className="transition-colors hover:text-slate-300">
              Privacy Policy
            </a>
            <a href="#top" data-testid="footer-terms" onClick={(e) => e.preventDefault()} className="transition-colors hover:text-slate-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="text-stroke-watermark pointer-events-none select-none whitespace-nowrap text-center font-display text-[18vw] font-extrabold leading-[0.75] tracking-tight"
      >
        BACKFILL
      </div>
    </footer>
  );
}
